import * as stylex from '@stylexjs/stylex';
import { colors } from '../theme/colors.stylex';

export const progressCircleStyles = stylex.create({
  sm: { width: '19px' },
  md: { width: '32px' },
  lg: { width: '35px' },
  root: { display: 'inline-block', verticalAlign: 'middle' },
  circle: { display: 'block', width: '100%' },
  trail: { stroke: colors.iconMuted, strokeLinecap: 'round' },
  progress: {
    stroke: colors.accent,
    strokeLinecap: 'round',
    transition: { 'default': 'stroke-dashoffset 0.5s ease', '@media (prefers-reduced-motion: reduce)': 'none' },
  },
  // A rounded cap would leave a colored dot at zero, so the stroke is hidden entirely.
  progressValue: (percentage: number) => ({ strokeDashoffset: 100 - percentage, opacity: percentage === 0 ? 0 : 1 }),
  label: { fill: colors.text, textAnchor: 'middle' },
  // px equals viewBox units here, so the size scales with the rendered diameter.
  labelSize: (fontSize: number) => ({ fontSize: `${fontSize}px` }),
});
